export default __webpack_public_path__ + "static/media/calendar_icon.6570cf59.svg";